<form #form="ngForm" class="p-3 mb-0 h-100">

  <xm-loader [showLoader]="loading$ | async"></xm-loader>

  <div class="d-flex justify-content-between block-sidebar-right-header">

    <button (click)="backToOrganisation()"
            [matTooltip]="TRS.back | translate"
            color="primary"
            mat-icon-button>
      <mat-icon>keyboard_backspace</mat-icon>
    </button>

    <h4 *ngIf="editType === EditType.Create" class="pt-2 ps-3">{{ TRS.addWidget | translate }}</h4>
    <h4 *ngIf="editType === EditType.Edit" class="pt-2 ps-3">{{ TRS.editWidget | translate }}</h4>

    <div class="d-flex flex-grow-1 ps-3 header-controls">
      <button (click)="onAdd()"
              *ngIf="editType === EditType.Create"
              [disabled]="!form.valid || disabled || !valid"
              color="primary"
              mat-flat-button>
        <mat-icon>create</mat-icon>
        {{ TRS.create | translate }}
      </button>

      <button (click)="onSave()"
              *ngIf="editType === EditType.Edit"
              [disabled]="!form.valid || disabled || !valid"
              [matTooltip]="(TRS.save | translate) + ' Ctrl+S'"
              color="primary"
              mat-icon-button>
        <mat-icon>save</mat-icon>
      </button>
      <xm-configuration-history [historyEvents]="historyEvents"
                                [config]="{itemType: 'widget', itemName: value?.name, changesType: 'config'}"></xm-configuration-history>

      <button (click)="onDelete()"
              *ngIf="editType === EditType.Edit"
              [disabled]="!form.valid  || disabled || !valid"
              [matTooltip]="TRS.delete | translate: { value: value.name }"
              mat-icon-button>
        <mat-icon>delete_outline</mat-icon>
      </button>

      <div class="ms-auto">
        <button
          *ngIf="editType === EditType.Edit"
          [disabled]="disabled || !valid"
          [matTooltip]="TRS.copyClipboard | translate"
          mat-icon-button
          [xmCopy]="{
                  data: this.getData(),
                }"
        >
          <mat-icon>content_copy</mat-icon>
        </button>

        <button
          *ngIf="editType === EditType.Create"
          [disabled]="disabled"
          [matTooltip]="TRS.paste | translate"
          mat-icon-button
          [xmPaste]="{
                  data: value,
                }"
          (eventValue)="eventValue($event)"
        >
          <mat-icon>content_paste</mat-icon>
        </button>

        <button (click)="onCancel()"
                [matTooltip]="TRS.cancel | translate"
                class="ms-auto"
                mat-icon-button>
          <mat-icon>cancel</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="section-scroll">

    <mat-tab-group [(selectedIndex)]="selectedIndex">
      <mat-tab [label]="TRS.info | translate">
        <div *ngIf="value.id">{{ TRS.id | translate }}: <span class="fw-bold">{{ value.id }}</span></div>

        <xm-text-control [(ngModel)]="formGroup.name"
                         [disabled]="disabled"
                         [config]="{ title: TRS.name }"
                         name="name"></xm-text-control>

        <xm-selector-text-control [(ngModel)]="formGroup.selector"
                                  [disabled]="disabled"
                                  (valueChange)="ngOnChanges({})"
                                  [options]="{ title: TRS.selector, required: true }"
                                  name="selector"></xm-selector-text-control>
      </mat-tab>

      <mat-tab [label]="TRS.config | translate">
        <div *ngIf="value.name">{{TRS.name | translate}}: <span class="fw-bold">{{value.name}}</span></div>
        <div *ngIf="value.selector">{{TRS.selector | translate}}: <span class="fw-bold">{{value.selector}}</span></div>

        <xm-config-editor [(ngModel)]="formGroup.config"
                          [disabled]="disabled"
                          name="editor"
        ></xm-config-editor>

      </mat-tab>

      <mat-tab [label]="TRS.editor | translate">
        <xm-schema-editor
          *ngIf="selectedIndex === 2"
          [options]="jsonEditorOptions"
          [ngModel]="formGroup.config"
          (ngModelChange)="formGroup.config = $event"
          [ngModelOptions]="{standalone: true}"
        ></xm-schema-editor>
      </mat-tab>

      <mat-tab [label]="TRS.samples | translate">
        <xm-widget-config-examples [value]="formGroup.selector"></xm-widget-config-examples>
      </mat-tab>

      <!--      <mat-tab [label]="'Docs'">-->
      <!--        <xm-doc-examples></xm-doc-examples>-->
      <!--        <ng-template mat-tab-label>-->
      <!--          Docs <a [routerLink]="'/dashboard/ui-docs'">-->
      <!--          <mat-icon>open_in_new</mat-icon>-->
      <!--        </a>-->
      <!--        </ng-template>-->
      <!--      </mat-tab>-->
    </mat-tab-group>

  </div>
</form>
